
import Vue from 'vue';
import ListItem from '@/components/base/ListItem.vue';
import BackButton from '@/components/base/BackButton.vue';
import StackLayers from '@/components/base/StackLayers.vue';
import BrandNewTeamSignup from '@/views/Team/TeamDashboard/BrandNewTeamSignup.vue';
import { mapState } from 'vuex';
import { TeamUserMixin } from '@/mixins';
import TeamPicker from '@/components/TeamPicker.vue';
import _isEmpty from 'lodash/isEmpty';

export default Vue.extend({
	name: 'TeamPlanSignup',
	mixins: [
		TeamUserMixin,
	],
	data () {
		return {
			newTeamOpen: false,
		};
	},
	computed: {
		...mapState([
			'team',
			'user',
		]),
	},
	methods: {
		_isEmpty,
		onSignUp () {
			this.newTeamOpen = true;
		},
	},
	components: {
		TeamPicker,
		BrandNewTeamSignup,
		StackLayers,
		BackButton,
		ListItem,
	},
});
